import React from "react";
// import Modal from "react-modal";
import Modal from "react-bootstrap/Modal";
import { ReusableOnboardingButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     transform: "translate(-50%, -50%)",
//     position: "relative",
//     padding: "0px",
//   },
// };

export const TogglePopup = ({
  togglePopupState,
  onClosedTogglePopup,
  onClickYesTogglePopup,
  afterOpenModal,
  displayAreyouOpen,
  displayMultipleOpen,
}) => {
  return (
    <React.Fragment>
      {/* <Modal
        isOpen={togglePopupState}
        onAfterOpen={afterOpenModal}
        onRequestClose={onClosedTogglePopup}
        style={customStyles}
        className="business_hours_model_popup"
        contentLabel="Example Modal"
        ariaHideApp={false}
      > */}

      <Modal
        show={togglePopupState}
        centered
        size="md"
        // className="business_hours_model_popup"
        onHide={onClosedTogglePopup}
        keyboard={false}
        // backdrop="static"
      >
        <Modal.Body>
          <div>
            <div className="header-box">
              {/* <h3>
              {displayAreyouOpen === true
                ? "Change Timing to Multiple Hours?"
                : "Change Timing to 24/7 ?" || displayMultipleOpen === true
                ? "Change Timing to 24/7 ?"
                : "Change Timing to Multiple Hours?"}
            </h3> */}
              <img
                src={require("../../../../../assets/images/AuthImages/menu.png")}
                className="img-fluid remove-button"
                title="Closed Button"
                alt="closed"
                style={{float : "right"}}
                // className="remove-button"
                onClick={onClosedTogglePopup}
              />
            </div>
            <div className="body-box">
              {displayAreyouOpen === false ? (
                <div>
                  <div className="f18-700 pb-2">Open for 24x7?</div>
                  <div className="f12-400 opacity5">
                    Are you sure you want to continue with 24x7?
                  </div>
                </div>
              ) : (
                <div>
                  <div className="f18-700 pb-2">
                    Do you want to change Timing to Multiple Hours?
                  </div>
                  <div className="f12-400 opacity5">
                    Are you sure to change Hours of Operation?
                  </div>
                </div>
              )}
              <div className="col-12 p-0 mt-4 d-flex align-items-center">
                <ReusableOnboardingButton
                  buttonTitle="No Button"
                  buttonClass="mr-3 onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="No"
                  buttonType="button"
                  onClick={onClosedTogglePopup}
                />
                <ReusableOnboardingButton
                  buttonType="button"
                  buttonTitle="Yes Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red "
                  buttonText="Yes"
                  onClick={onClickYesTogglePopup}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
